exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.search[data-v-4ad41bb8] {\n  border-bottom: 1px solid #d8dfe7;\n}\n@media screen and (max-width: 1024px) {\n.search[data-v-4ad41bb8] {\n      border-bottom: 0;\n}\n}\n.search .input[data-v-4ad41bb8] {\n    outline: none;\n    width: 100%;\n    height: 3.5em;\n    padding: 0 1em;\n    border: 0px;\n    font-size: 0.9em;\n}\n", ""]);

// exports
